/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading dependencies
 * -----------------------------------------------------------------------------------------------------------
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import { Notification } from 'element-ui'
import ls from 'src/libs/ls'
/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import gsTable from 'components/app/gsTable/store'
import account from 'components/account/store'
import city from 'components/city/store'
import district from 'components/district/store'
import ward from 'components/ward/store'
import service from 'components/service/store'
import region from 'components/region/store'
import carrier from 'components/carrier/store'
import priceTable from 'components/pricetable/store'
import block from 'components/block/store'
import postOffice from 'components/postOffice/store'
import blog from 'components/blog/store'
import category from 'components/category/store'
import address from 'components/address/store'
import client from 'components/client/store'
import promotion from 'components/promotion/store'
import bank from 'components/bank/store'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Vuex base configurations
 * -----------------------------------------------------------------------------------------------------------
 */
Vue.use(Vuex)
import router from 'src/router'
const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  strict: debug,
  state: {
    loading: false,
    logged: false,
    loadingInstance: undefined,
    debugQuery: []
  },
  actions: {
    showNotify: ({commit}, message) => {
      Notification({
        title: message.title,
        message: message.body,
        type: message.type ? message.type : 'success'
      })
    },
    logged ({commit}, token) {
      ls.set('authen', token)
      commit('setLogged')
    },
    logout ({commit}) {
      ls.remove('authen')
      commit('setLogout')
    },
    toggleLoadding ({commit}, loading = true) {
      commit('loading', loading)
    },
    checkLogged ({commit}) {
      if (ls.get('authen')) {
        commit('setLogged')
      } else {
        router.push('/login')
      }
    }
  },
  mutations: {
    loading (state, loading) {
      state.loading = loading
    },
    setLogged (state) {
      state.logged = true
    },
    setLogout (state) {
      state.logged = false
    },
    SET_DEBUG (state, queries) {
      state.debugQuery.push(queries)
    }
  },
  getters: {
    loading: (state) => state.loading,
    isLogged: state => state.logged,
    debugQuery: state => state.debugQuery
  },
  modules: {
    gsTable,
    account,
    city,
    district,
    region,
    service,
    carrier,
    priceTable,
    block,
    postOffice,
    blog,
    category,
    ward,
    address,
    client,
    promotion,
    bank
  },
  plugins: debug ? [createLogger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js